import React from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles'
import { Box, FormControl, FormHelperText, Grid, InputLabel, Typography } from '@material-ui/core'

import { MyServerTable } from './MyServerTable'
import { BootstrapInput } from './BootstrapInput'
import { StoreTableHasMsProductFilter } from './StoreTableHasMsProductFilter'
import { ExportFileKind, ExportToExcelButton } from './ExportToExcelButton'

import { YandexMarketProductsTableData } from '../store/productStore'

import { TableColumn } from '../types/tableTypes'
import { YandexMarketProductColumnId } from '../types/yandexMarketColumns'
import { YandexMarketProductModel } from '../server/mpsklad_core/Models/YandexMarketProductModel'

import { useApi } from '../hooks/storeHook'

export type YandexMarketProductsTableProps = {
  products: YandexMarketProductsTableData

  columns: Array<TableColumn<YandexMarketProductColumnId, YandexMarketProductModel>>

  accountId?: number
  accountName?: string
}

export const YandexMarketProductsTable =
  observer(
    ({products, columns, accountId, accountName}: YandexMarketProductsTableProps) => {
      const classes = useStyles()
      const api = useApi()

      return (
        <Grid item lg={12} xl={12}>
          <Box className={clsx(classes.container, 'default-border')}>
            <Box paddingTop={1} marginY={2} marginLeft={2} display="flex" alignItems="center">
              <Typography className={classes.label}>
                Товары
              </Typography>

              {
                accountId !== undefined &&
                <Box marginLeft={2}>
                  <ExportToExcelButton
                    fileKind={ExportFileKind.Products}
                    columns={columns}
                    accountName={accountName}
                    makeExportRequest={columnIds => api.product.exportYandexMarketToExcel({
                      ...products.getExportOptions(),
                      accountId,
                      columnIds
                    })}
                  />
                </Box>
              }

              <Box marginLeft={25}>
                <Box>
                  <FormControl fullWidth>
                    <InputLabel shrink htmlFor="search-yandexMarket">
                      Поиск
                    </InputLabel>

                    <BootstrapInput
                      id="search-yandexMarket"
                      placeholder="Поиск"
                      onChange={e => products.setGlobalFilter(e.target.value)}
                      inputProps={{'aria-label': 'Поиск'}}
                      fullWidth
                      className={classes.input}
                    />

                    <FormHelperText className={classes.input}>
                      Id / Наименование / Ваш SKU / Артикул / Штрихкод
                    </FormHelperText>
                  </FormControl>
                </Box>
              </Box>

              <Box marginLeft={5}>
                <StoreTableHasMsProductFilter products={products}/>
              </Box>
            </Box>

            <MyServerTable
              tableProps={{size: 'small'}}
              table={products}
              columns={columns}
              labelNoRows="Товаров нет"
              labelNotFound="Товары не найдены"
              labelRowsPerPage="Товаров на странице:"
            />
          </Box>
        </Grid>
      )
    })

const useStyles = makeStyles(() => ({
  container: {
    width: 'calc(100vw - 390px)',
    borderRadius: 12,
    padding: 15,
    margin: '20px 10px 0 10px'
  },
  label: {
    fontSize: 14,
    padding: 10
  },
  input: {
    fontSize: 12
  }
}))